import crud from './helpers/crud';
import posthog from 'posthog-js';

const sendToMultipleRecipients = (id, receivers, canSend, documentType, subject, memo, signatureRequired, callerId, allowPatientEdits, org = '', contact = '', removeCoversheet = false, scheduledDateTime = null) => (
  crud({
    dispatch: {
      begin: 'BEGIN_SEND_TO_MULTIPLE_RECIPIENTS',
      fail: 'FAILED_SEND_TO_MULTIPLE_RECIPIENTS',
      end: 'FINISHED_SEND_TO_MULTIPLE_RECIPIENTS',
    },
    method: 'POST',
    url: `/api/v1/records/${id}/send_to_multiple_users`,
    data: {
      receivers,
      can_send: canSend,
      document_type: documentType,
      signature_required: signatureRequired,
      subject,
      memo,
      caller_id: callerId,
      receiver_org: receivers.length === 1 ? org : null,
      receiver_name: receivers.length === 1 ? contact : null,
      remove_cover_sheet: removeCoversheet,
      editable: allowPatientEdits,
      scheduled_date_time: scheduledDateTime,
    },
    onSuccess: () => {
      if (process.env.NODE_ENV !== 'development' && posthog) {
        posthog.capture('send_to_multiple_recipients', {
          id,
          receivers,
          documentType,
          signatureRequired,
          subject,
          memo,
          callerId,
          receiverOrg: receivers.length === 1 ? org : null,
          receiverName: receivers.length === 1 ? contact : null,
          removeCoversheet,
          allowPatientEdits,
          editable: allowPatientEdits,
          scheduledDateTime,
        });
      }
    },
  })
);

const sendPatientRecord = (id, patient, memo, disableSecureReplies) => {
  const name = [patient.firstName, patient.middleName, patient.lastName]
    .filter(Boolean)
    .join(' ');

  return crud({
    dispatch: {
      begin: 'BEGIN_SEND_PATIENT_RECORD',
      fail: 'FAILED_SEND_PATIENT_RECORD',
      end: 'FINISHED_SEND_PATIENT_RECORD',
    },
    method: 'POST',
    url: `/api/v1/records/${id}/send_to_patient`,
    data: {
      patient: {
        recipient: patient.recipient,
        dob: patient.dob,
        name,
        first_name: patient.firstName,
        middle_name: patient.middleName,
        last_name: patient.lastName,
        force: patient.force,
        signature_required: patient.signatureRequired,
        note: memo,
        disable_replies: disableSecureReplies,
      },
    },
    onSuccess: () => {
      if (process.env.NODE_ENV !== 'development' && posthog) {
        posthog.capture('send_patient_record', {
          id,
          recipient: patient.recipient,
          dob: patient.dob,
          name,
          firstName: patient.firstName,
          middleName: patient.middleName,
          lastName: patient.lastName,
          force: patient.force,
          signatureRequired: patient.signatureRequired,
          note: memo,
          disableSecureReplies,
        });
      }
    },
  });
};

const sendToDistributionList = (recordId, distributionListSlug, memo, documentType, subject, signatureRequired, callerId, allowPatientEdits, removeCoversheet, scheduledDateTime) => (
  crud({
    dispatch: {
      begin: 'BEGIN_SEND_TO_DISTRIBUTION_LIST',
      fail: 'FAILED_SEND_TO_DISTRIBUTION_LIST',
      end: 'FINISHED_SEND_TO_DISTRIBUTION_LIST',
    },
    method: 'POST',
    url: `/api/v1/records/${recordId}/send_to_multiple_users`,
    data: {
        is_distribution_list: true,
        distribution_list_slug: distributionListSlug,
        receivers: [],
        can_send: true,
        document_type: documentType,
        signature_required: signatureRequired,
        subject,
        memo,
        caller_id: callerId,
        receiver_org: null,
        receiver_name: null,
        remove_cover_sheet: removeCoversheet,
        editable: allowPatientEdits,
        scheduled_date_time: scheduledDateTime,
      },
    onSuccess: () => {
      if (process.env.NODE_ENV !== 'development' && posthog) {
        posthog.capture('send_to_distribution_list', {
          recordId,
          distributionListSlug,
          documentType,
          signatureRequired,
          subject,
          memo,
          callerId,
          removeCoversheet,
          editable: allowPatientEdits,
          scheduledDateTime,
        });
      }
    },
  })
);

const sendBulkRecords = (recordIds, receivers, canSend, documentType, subject, memo, signatureRequired, callerId, allowPatientEdits, removeCoversheet = false, scheduledDateTime = null, distributionList = null, org = '', contact = '') => (
  crud({
    dispatch: {
      begin: 'BEGIN_SEND_BULK_RECORDS',
      fail: 'FAILED_SEND_BULK_RECORDS',
      end: 'FINISHED_SEND_BULK_RECORDS',
    },
    method: 'POST',
    url: '/api/v1/records/bulk_send',
    data: {
      record_ids: recordIds,
      receivers,
      can_send: distributionList ? true : canSend,
      document_type: documentType,
      signature_required: signatureRequired,
      subject,
      memo,
      caller_id: callerId,
      receiver_org: receivers.length === 1 ? org : null,
      receiver_name: receivers.length === 1 ? contact : null,
      remove_cover_sheet: removeCoversheet,
      editable: allowPatientEdits,
      scheduled_date_time: scheduledDateTime,
      ...(distributionList && {
        is_distribution_list: true,
        distribution_list_slug: distributionList.slug,
      }),
    },
    onSuccess: () => {
      if (process.env.NODE_ENV !== 'development' && posthog) {
        posthog.capture('send_bulk_records', {
          recordIds,
          receivers,
          documentType,
          signatureRequired,
          subject,
          memo,
          callerId,
          receiverOrg: receivers.length === 1 ? org : null,
          receiverName: receivers.length === 1 ? contact : null,
          removeCoversheet,
          allowPatientEdits,
          scheduledDateTime,
          distributionList: distributionList?.slug,
        });
      }
    },
  })
);

export {
  sendToDistributionList,
  sendPatientRecord,
  sendToMultipleRecipients,
  sendBulkRecords,
};
